<template>
    <div>
        <div class="clearfix mt-2  text-left" >
            {{$t(record.text)}}
        </div>
        
    </div>
</template>

<script>
    export default {
        props: {
            record: {
                type: Object,
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>